import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {select, Store} from '@ngrx/store';
import {takeUntil} from 'rxjs/operators';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';

@Component({
    standalone: false,
    selector: 'particle-filing-export-dialog',
  templateUrl: './filing-export-dialog.component.html',
  styleUrls: ['./filing-export-dialog.component.scss']
})
export class FilingExportDialogComponent implements OnInit, OnDestroy {
  unSubscribe$ = new Subject<void>();
  filterId: string;
  filterTemplateId: string;
  invalidateSubject: InvalidateSubject;
  apiKey: string;
  leftSourceType: string;
  input: any;
  message: string;
  rightElementsCount: any;
  filingExportOptions: any;
  selectedExportOptions: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private queryStore: Store<IQueryState>,
              public dialogRef: MatDialogRef<FilingExportDialogComponent>) { }

  ngOnInit() {
    this.filterId = this.data.filterId;
    this.filterTemplateId = this.data.filterTemplateId;
    this.apiKey = this.data.apiKey;
    this.leftSourceType = this.data.leftSourceType ? this.data.leftSourceType : null;
    this.input = this.data.input ? this.data.input : null;
    this.message = this.data.message ? this.data.message : null;
    this.invalidateSubject = this.data.invalidateSubject ? this.data.invalidateSubject : new InvalidateSubject();
    this.queryStore.pipe(takeUntil(this.unSubscribe$), select(getQueryResponse, 'GetFilingOptionsConfig')).subscribe(options => {
      if (options) {
        this.filingExportOptions = options;
        this.selectedExportOptions = options.ExportOptions.find(option => option.DownloadType === options.DefaultDownloadType);
      }
    });
    if (this.data.sourceTYpe){
      QueryProvider.invokeQuery(this.queryStore, 'GetFilingOptionsConfig', {'[CODE]': this.data.countryCode, '[SOURCE_TYPE]': this.data.sourceTYpe});
    }
    else{
      console.error("SourceType not found on compont 'FilingExportDialogComponent'. See the data:::", this.data);
      QueryProvider.invokeQuery(this.queryStore, 'GetFilingOptionsConfig', {'[CODE]': this.data.countryCode, '[SOURCE_TYPE]': ''});
    }
  }
  onOkClicked(): any {
    this.dialogRef.close({
      rightElementsCount: this.rightElementsCount,
      downloadType: this.selectedExportOptions.DownloadType
    });
  }
  onCancel() {
    this.dialogRef.close();
  }
  transferCount(event) {
    this.rightElementsCount = event;
  }
  onExportOptionsSelectionChange(event) {
    this.selectedExportOptions = event.value;
  }
  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
